
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/[product]/onboarding",
      function () {
        return require("private-next-pages/[company]/[product]/onboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/[product]/onboarding"])
      });
    }
  